<template>
    <div></div>
</template>

<script>
import { mapMutations } from 'vuex'

/**
 * 他ユーザモードのstateをクリアする
 * （stateが残っていると不都合が生じるものだけ対象）
 */
export default {
    props: {
        userType: {
            type: String,
            required: true,
        },
    },

    created: function () {
        if (this.userType === 'admin') {
            // 医師メニューの設定画面で不正な割引表示とならないようにクリア
            this.setRecentlyConsultations([])
        } else if (this.userType === 'doctor') {
            // 医師による相談予約時に不正な割引表示とならないようにクリア
            this.setRecentlyConsultations([])
        }
    },

    methods: {
        ...mapMutations({
            setRecentlyConsultations: 'userConsultations/setRecentlyConsultations',
        }),
    },
}
</script>
